import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/select.png';

const _withScopeId = n => (_pushScopeId("data-v-52dcaa6c"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "head_title"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "观看记录", -1));

const _hoisted_3 = {
  key: 1,
  class: "cont_body"
};
const _hoisted_4 = {
  key: 0,
  class: "info-recommend"
};
const _hoisted_5 = {
  class: "video_list"
};
const _hoisted_6 = ["onClick"];

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));

const _hoisted_8 = [_hoisted_7];
const _hoisted_9 = {
  key: 1,
  class: "no-data"
};
const _hoisted_10 = {
  class: "btns"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");

  const _component_Loading = _resolveComponent("Loading");

  const _component_video_item = _resolveComponent("video-item");

  const _component_van_list = _resolveComponent("van-list");

  const _component_no_data = _resolveComponent("no-data");

  const _component_van_popup = _resolveComponent("van-popup");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_van_icon, {
    size: "22",
    name: "arrow-left",
    onClick: $setup.close
  }, null, 8, ["onClick"]), _hoisted_2, _createElementVNode("span", {
    class: "right_text",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.edit && $setup.edit(...args))
  }, _toDisplayString(!$setup.isEdit ? "编辑" : "取消"), 1)]), $setup.showLoading ? (_openBlock(), _createBlock(_component_Loading, {
    key: 0
  })) : (_openBlock(), _createElementBlock("div", _hoisted_3, [$setup.videoList.length ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_van_list, {
    loading: $setup.loading,
    "onUpdate:loading": _cache[1] || (_cache[1] = $event => $setup.loading = $event),
    error: $setup.error,
    "onUpdate:error": _cache[2] || (_cache[2] = $event => $setup.error = $event),
    finished: $setup.finished,
    "error-text": "请求失败，点击重新加载",
    "finished-text": "-我也是有底线的-",
    "loading-text": "正在获取数据...",
    onLoad: $setup.onLoad
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.videoList, item => {
      return _openBlock(), _createElementBlock("div", {
        key: item.id,
        class: "video_item_box"
      }, [$setup.isEdit ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "select_box",
        onClick: $event => $setup.videoSelect(item)
      }, [_createElementVNode("div", {
        class: _normalizeClass(["video_select", item.select ? 'active' : ''])
      }, _hoisted_8, 2)], 8, _hoisted_6)) : _createCommentVNode("", true), (_openBlock(), _createBlock(_component_video_item, {
        key: item.id,
        dataItem: item
      }, null, 8, ["dataItem"]))]);
    }), 128))])]),
    _: 1
  }, 8, ["loading", "error", "finished", "onLoad"])])) : (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_no_data, {
    color: "#ffffff"
  })]))]))]), _createVNode(_component_van_popup, {
    show: $setup.isEdit,
    "onUpdate:show": _cache[5] || (_cache[5] = $event => $setup.isEdit = $event),
    overlay: false,
    position: "bottom"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", {
      class: "item",
      onClick: _cache[3] || (_cache[3] = (...args) => $setup.selectAll && $setup.selectAll(...args))
    }, "全选"), _createElementVNode("div", {
      class: "item del",
      onClick: _cache[4] || (_cache[4] = (...args) => $setup.delVideo && $setup.delVideo(...args))
    }, "删除")])]),
    _: 1
  }, 8, ["show"])], 64);
}